import { render, staticRenderFns } from "./RecentAlimTalkList.vue?vue&type=template&id=2f95ebda"
import script from "./RecentAlimTalkList.vue?vue&type=script&lang=js"
export * from "./RecentAlimTalkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports